import { css } from "lit";

/** sugar-room-designer shell — shadow DOM’lar arası inherit edilir */
export const designTokensCss = css /*css*/`
  :host {
    --srd-font: "DM Sans", sans-serif;
    --srd-bg: #f3f4f6;
    --srd-bg-muted: #e8eaed;
    --srd-surface: rgba(255, 255, 255, 0.88);
    --srd-surface-solid: #ffffff;
    --srd-surface-hover: #ffffff;
    --srd-border: rgba(15, 23, 42, 0.08);
    --srd-border-strong: rgba(15, 23, 42, 0.14);
    --srd-text: #0f172a;
    --srd-text-muted: #64748b;
    --srd-accent: #9fb8a9;
    --srd-accent-hover: #8fa698;
    --srd-accent-soft: rgba(159, 184, 169, 0.18);
    --srd-selected: #9fb8a9;
    --srd-button: #9fb8a9;
    --srd-button-hover: #8fa698;
    --srd-button-text: #1f2937;
    --srd-toolbar-selected-bg: var(--srd-button);
    --srd-toolbar-selected-bg-hover: var(--srd-button-hover);
    --srd-toolbar-selected-border: #ffffff;
    --srd-toolbar-selected-fg: #ffffff;
    --srd-view-toggle-active-bg: #abc1b7;
    --srd-view-toggle-active-text: #24332e;
    --srd-view-toggle-passive-text: #6b7772;
    --srd-view-toggle-border: #e6eae7;
    --srd-view-toggle-hover-bg: #f3f5f4;
    --srd-chrome-icon-passive: #9aa5a0;
    --srd-chrome-icon-hover-bg: #e6eae7;
    --srd-chrome-icon-hover-fg: #24332e;
    --srd-chrome-icon-active-bg: #a8c1b7;
    --srd-chrome-icon-active-fg: #24332e;
    --srd-danger: #dc2626;
    --srd-radius-sm: 8px;
    --srd-radius-md: 12px;
    --srd-radius-lg: 16px;
    --srd-radius-pill: 999px;
    --srd-shadow-sm: 0 1px 2px rgba(15, 23, 42, 0.05),
      0 1px 3px rgba(15, 23, 42, 0.04);
    --srd-shadow-md: 0 4px 12px rgba(15, 23, 42, 0.08),
      0 2px 4px rgba(15, 23, 42, 0.04);
    --srd-shadow-lg: 0 16px 40px rgba(15, 23, 42, 0.12);
    --srd-blur: blur(14px);
    --srd-space-1: 4px;
    --srd-space-2: 8px;
    --srd-space-3: 12px;
    --srd-space-4: 16px;
    --srd-space-5: 24px;
    --srd-transition: 160ms ease-out;
    --srd-focus-ring: 0 0 0 2px var(--srd-surface-solid),
      0 0 0 4px var(--srd-accent-soft);
    --srd-tool-size: 44px;
    --srd-font-size-section: 0.75rem;
    --srd-font-weight-section: 500;
    --srd-line-height-section: 1.15;
    --srd-letter-spacing-section: -0.03em;
    --srd-font-size-item: 0.875rem;
    --srd-font-size-item-sm: 0.625rem;
    font-family: var(--srd-font);
    color: var(--srd-text);
    -webkit-font-smoothing: antialiased;
  }
`;

const DM_SANS_FONT_URL =
  "https://fonts.googleapis.com/css2?family=DM+Sans:ital,opsz,wght@0,9..40,100..1000;1,9..40,100..1000&display=swap";

/** Embed / shadow DOM dışında font yüklenmemişse Google Fonts'tan ekler */
export function ensureDmSansFont(): void {
  const id = "srd-dm-sans-font";
  if (document.getElementById(id)) return;
  const link = document.createElement("link");
  link.id = id;
  link.rel = "stylesheet";
  link.href = DM_SANS_FONT_URL;
  document.head.appendChild(link);
}
